<template>
  <footer class="footer" v-if="$store.state.iframeMode === false">
    <div class="container">
      <div class="footer-copy" v-if="$route.path !== '/finder'">
        <img class="logo-heraklith" :src="require('@/assets/img/logo_text.svg')" alt="Heraklith" />
        <p>Der Spagat zwischen Funktion und Ästhetik: Vermutlich wird dieser von kaum einem anderen Produkt so gut gemeistert wie von Heraklith Holzwolle-Produkten. Dank A2-Ausführung erfüllen sie höchste Anforderungen an den Brandschutz, sie schützen effektiv vor Wärmeverlusten und dämmen den Schall.</p>

        <div class="footer-brand">
          Eine Marke von <img class="logo-knaufinsulation" :src="require('@/assets/img/logo_knauf_insulation.svg')" alt="Knauf Insulation" />
        </div>
      </div>

      <ul class="footer-navigation">
        <li class="footer-navigation__item">
          <a class="footer-navigation__link" href="https://www.heraklith.de/datenschutz" target="_blank">Datenschutz</a>
        </li>
        <li class="footer-navigation__item">
          <a class="footer-navigation__link" href="https://www.heraklith.de/impressum" target="_blank">Impressum</a>
        </li>
        <li class="footer-navigation__item">
          <a class="footer-navigation__link" href="https://www.heraklith.de/" target="_blank">Zur Website</a>
        </li>
      </ul>

      <div class="copyright">© {{ getCurrentYear() }} Heraklith</div>
    </div>
  </footer>
</template>

<script>
export default {
  props: {
    minimal: {
      type: Boolean,
      required: false,
    },
  },
  methods: {
    getCurrentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style scope lang="scss">
.footer {
  background-color: $color-contrast-dark;
  padding: 30px 0;
  color: rgba($color-white, .5);

  @include tablet {
    text-align: center;
  }
}

.footer-copy {
  margin-bottom: 25px;
  padding-bottom: $section-spacing;
  border-bottom: 1px solid rgba($color-white, .2);
}

.logo-heraklith {
  width: auto;
  height: 22px;
  margin-bottom: 25px;
}

.footer-brand {
  margin-top: $section-spacing;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: $color-white;
  text-transform: uppercase;
}

.logo-knaufinsulation {
  width: auto;
  height: 40px;
  margin-left: 12px;
}

.footer-navigation {
  margin: 0 0 20px 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  list-style: none;

  &__link {
    display: block;
    color: $color-primary;
    text-decoration: none;

    &:hover,
    &:focus {
      color: $color-white;
    }
  }

  @include tablet {
    justify-content: center;

    &__link {
      margin: 0 22px;
    }
  }
}

.copyright {
  font-size: 12px;
  text-align: center;
}
</style>
